import React from 'react'
import Sales from '../components/Sales/Sales'

const SalesPage = () => {
  return (
    <Sales/>
  )
}

export default SalesPage